import { render, staticRenderFns } from "./JdsNotificationBadge.vue?vue&type=template&id=296339c3&scoped=true&"
import script from "./JdsNotificationBadge.vue?vue&type=script&lang=ts&"
export * from "./JdsNotificationBadge.vue?vue&type=script&lang=ts&"
import style0 from "./JdsNotificationBadge.vue?vue&type=style&index=0&id=296339c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296339c3",
  null
  
)

export default component.exports